import React from "react";

import { useTranslation } from "react-i18next";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";

import { MessageContainer } from "../MessageContainer";

export const EXEWidgetContainer = (props: {
	eventId: string;
	location: WidgetLocation;
	divProps?: React.HTMLProps<HTMLDivElement>;
}) => {
	const { t } = useTranslation();
	const store = useLiveWidgetStore();
	const activeWidget = store.findActiveLmtWidget(
		props.eventId,
		props.location
	);

	if (activeWidget?.isError) {
		return (
			<div {...props.divProps}>
				<MessageContainer
					message={t<string>("LIVE_WIDGET.FALLBACK_MESSAGE")}
					isError={true}
					location={props.location}
				/>
			</div>
		);
	}

	return (
		<div {...props.divProps}>
			<iframe
				src={activeWidget?.ExeWidgetOptions?.LMTWithoutStatistics?.(
					activeWidget.matchId
				)}
				allowFullScreen
				frameBorder={0}
				className="widget--exe__iframe"
			/>
		</div>
	);
};
